export default "__VITE_ASSET__DpoM0oJz__"